import React from 'react'
import { useMemo } from 'sb-hooks'
import { array } from 'common/helpers'

import { Row } from 'components/_new/layout'

import Star from './Star/Star'


type RatingProps = {
  className?: string
  starClassName?: string
  value: number
}

const Rating: React.FunctionComponent<RatingProps> = ({ className, starClassName, value }) => {
  const starsFill = useMemo(() => {
    const ceilValue = Math.ceil(value)

    return array.range(1, 5).map((count) => {
      if (count === ceilValue) {
        const fillValue = (value + 1 - count) * 100

        if (fillValue < 35) {
          return 35
        }
        if (fillValue < 75) {
          return 75
        }

        return fillValue
      }

      return count <= ceilValue ? 100 : 0
    })
  }, [ value ])

  return (
    <Row className={className} align="center" justify="start">
      {
        starsFill.map((starFill, index) => (
          <Star
            key={index}
            className={starClassName}
            value={starFill}
          />
        ))
      }
    </Row>
  )
}


export default Rating
